module.exports = __webpack_public_path__ + "static/media/Mulish-Regular.e8255fc5.ttf";